<!--
 * @Descripttion: 基本属性
 * @Author: zenghua.wang
 * @Date: 2021-04-25 14:43:29
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-05 15:01:20
-->
<template>
  <div>
    <el-form-item :label="component.prop">
      <el-input
        v-model="data.prop"
        readonly
        placeholder="属性值"
      ></el-input>
    </el-form-item>

    <el-form-item :label="component.label">
      <el-input
        v-model="data.label"
        clearable
        placeholder="请输入名称"
      />
    </el-form-item>

    <el-form-item
      :label="component.width"
      v-if="main.vaildNumber(data.width)"
    >
      <el-input-number
        v-model="data.width"
        placeholder="请输入"
      />
    </el-form-item>

    <el-form-item
      v-if="main.vaildNumber(data.height)"
      :label="component.height"
    >
      <el-input-number
        v-model="data.height"
        placeholder="请输入"
      />
    </el-form-item>

    <!-- 数据大屏坐标设置 -->
    <template v-if="category == 'screen'">
      <el-form-item :label="component.left">
        <el-input-number
          v-model="data.left"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item :label="component.top">
        <el-input-number
          v-model="data.top"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="组件层级">
        <el-input-number
          v-model="data.index"
          placeholder="请输入"
          :min="1"
        />
      </el-form-item>
    </template>
  </div>
</template>

<script>
import { component } from '@/dragComponents/model/default.js'
export default {
  name: 'config-base',
  inject: ['main', 'category'],
  props: ['data'],
  data() {
    return {
      component: component
    }
  }
}
</script>
